export default "__VITE_ASSET__DwP7cXpD__"